import { createAsyncThunk } from '@reduxjs/toolkit';
import apiConfig from 'constants/apiConfig';
import { fetchRecommendedCreators } from 'services/api/campaign';
import { ERROR } from 'types';
import {
    RecommendedCreatorsFilters,
    RecommendedCreatorsResponse,
    RecommendedCreatorsSlice,
} from 'types/creator-discovery';
import { generateUniqueKey, getErrorMessage, isFresh } from 'utils/helpers';

export const fetchRecommendedCreatorsThunk = createAsyncThunk<
    {
        campaignId: string;
        filters: RecommendedCreatorsFilters;
        filterId: string;
        data: RecommendedCreatorsResponse;
    },
    { campaignId: string; filters: RecommendedCreatorsFilters; force?: boolean },
    { rejectValue: string }
>(
    'campaignRecommendedCreators/fetch',
    async ({ campaignId, filters, force = false }, { getState, rejectWithValue }) => {
        try {
            const STALE_TIME = apiConfig.FETCH_RECOMMENDED_CREATORS.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as { campaignRecommendedCreators: RecommendedCreatorsSlice };

            if (
                filters.page === 1 &&
                !force &&
                isFresh(
                    state.campaignRecommendedCreators.campaigns[campaignId]?.filtered_lists?.[filterId]
                        ?.last_fetched_at ?? null,
                    STALE_TIME
                )
            ) {
                return rejectWithValue(ERROR.CACHED);
            }

            const data = await fetchRecommendedCreators(campaignId, filters.page, filters.sort);
            return { campaignId, filters, filterId, data };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch recommended creators'));
        }
    }
);
